<template>
  <div class="container-fluid d-flex flex-column flex-grow-1">
    <div class="d-flex align-items-center">
      <h2 class="page-heading mr-auto">Чек-листы</h2>
      <div class="input-group mr-2" style="max-width: 30em;">
        <select v-model="selectedMachineType" class="custom-select">
          <option value="">Тип автомата...</option>
          <option v-for="type in machineTypes" :value="type">{{type.name}}</option>
        </select>
        <select v-model="selectedTaskType" class="custom-select">
          <option value="">Тип задачи...</option>
          <option v-for="type in taskTypes" :value="type">{{type.name}}</option>
        </select>
      </div>
      <button type="button" :disabled="selectedMachineType === '' || selectedTaskType === ''" class="btn btn-primary" @click="checklist()">Добавить элемент</button>
    </div>

    <div class="table-full-width flex-grow-1 bg-white d-flex flex-column">
      <table class="table mb-0">
        <thead>
        <tr><th>Элементы чек-листа</th></tr>
        </thead>
      </table>

      <height-tracker class="container-fluid flex-grow-1">
        <div class="table-full-width" slot-scope="{ height }">
          <div ref='content' :style="'overflow-y: auto; height: ' + height + 'px'">
            <draggable v-model="currentChecklist">
              <div v-for="element in currentChecklist">
                <div class="d-flex flex-row p-2 washy-bottom">
                  <div>{{element.name}}</div>
                  <div class="ml-auto text-nowrap">
                    <button @click="edit(element)" class="btn btn-sm btn-outline-light">Редактировать</button>
                    <btn-action @click="() => remove(element)" class="btn btn-sm btn-outline-light">Удалить</btn-action>
                  </div>
                </div>
              </div>
            </draggable>
            <slot/>
          </div>
        </div>
      </height-tracker>
    </div>
  </div>
</template>

<script>
  import draggable from 'vuedraggable'
  import api from '@/api'
  import ChecklistModal from '../../../components/checklist-modal.vue'

  export default {
    metaInfo: {title: 'Чек-листы'},
    components: {
      draggable,
    },
    data () {
      return {
        currentChecklist: null,
        selectedMachineType: '',
        selectedTaskType: '',
        moving: null,
      }
    },
    methods: {
      checklist (name = '', description = '', order = this.currentChecklist.length, id = 0, elementType = null) {
        this.$root.showModal(ChecklistModal, {
          machine_type_id: this.selectedMachineType.id,
          task_type_id: this.selectedTaskType.id,
          name_prop: name,
          description_prop: description,
          id: id,
          order_number: order,
          element_type: elementType,
        }).then((data) => {
          if (data !== undefined) {
            let element = this.currentChecklist.find((current) => current.id === id)
            if (element !== undefined) {
              Object.assign(element, data)
            } else {
              this.currentChecklist.push(data)
            }
          }
        })
      },
      edit (element) {
        this.checklist(element.name, element.description, element.order_number, element.id, element.type)
      },
      remove (element) {
        if (!window.confirm('Подтвердить удаление ?')) return

        return api.delete('checklists/' + element.id).then(() => {
          this.currentChecklist.splice(this.currentChecklist.indexOf(element), 1)
        })
      },
    },
    watch: {
      currentChecklist (list) {
        if (list !== undefined) {
          api.post('checklists/order', {
            ids: Array.map(list, (current) => current.id),
          })
        }
      },
    },
    asyncComputed: {
      taskTypes () {
        return api
          .get('tasks')
          .then(({data}) => data.data)
      },
      machineTypes () {
        return api
          .get('machines/types')
          .then(({data}) => data.data)
      },
      elements () {
        if (this.selectedMachineType !== '' && this.selectedTaskType !== '') {
          api.get('checklists/elements', {
            params: {
              task_type_id: this.selectedTaskType.id,
              machine_type_id: this.selectedMachineType.id,
            },
          }).then(({data}) => {
            this.currentChecklist = data.data
          })
        }
      },
    },
  }
</script>

<style lang="scss">
  .washy-bottom {
    border-bottom: 1px solid #F7FAFB;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/admin/documents/checklists.vue